import React, { useRef, useEffect } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, content, containerPadding = true, clickOutsideClose = true }) => {
    const modalRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (clickOutsideClose) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div className='modalBackdrop'>
            <div ref={modalRef} className={`modalContent ${!containerPadding ? 'no-padding' : ''}`}>
                {content}
            </div>
        </div>
    );
};

export default Modal;
